import type { ReactNode } from 'react';
import { useEffect, useRef, useState } from 'react';

interface UseReducedMotionResult {
  prefersReducedMotion: boolean;
}

export const useReducedMotion = (): UseReducedMotionResult => {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);
  const mediaQueryRef = useRef<MediaQueryList | null>(null);

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    mediaQueryRef.current = mq;
    setPrefersReducedMotion(mq.matches);

    const handler = (event: MediaQueryListEvent): void => {
      setPrefersReducedMotion(event.matches);
    };

    mq.addEventListener('change', handler);
    return () => {
      mq.removeEventListener('change', handler);
    };
  }, []);

  return { prefersReducedMotion };
};

export const noop = (): ReactNode => null;
